import React, { Component } from 'react';

/**
 * Buttons stacked above the launcher. Real <button> and <a> elements, so keyboard and
 * screen reader behaviour comes from the platform, grouped under one labelled region.
 */
export default class QuickButtons extends Component {
    render() {
        const { buttons, launcherSize, isMobile, groupLabel, dismissLabel, onAction, onDismiss } = this.props;
        const size = Number(launcherSize) || 56;
        // The label sits level with the launcher, so this stack clears both.
        const bottom = size + 12;

        const buttonStyle = {
            display: 'block',
            maxWidth: '100%',
            boxSizing: 'border-box',
            background: 'var(--lc-surface, #fff)',
            color: 'var(--lc-text, #1e293b)',
            border: 'var(--lc-hairline)',
            borderRadius: 'var(--lc-radius-full)',
            boxShadow: 'var(--lc-shadow-2)',
            padding: isMobile ? '8px 14px' : '9px 16px',
            fontSize: isMobile ? 13 : 14,
            fontWeight: 500,
            lineHeight: 1.3,
            textAlign: 'right',
            textDecoration: 'none',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        };

        return (
            <div
                role="group"
                aria-label={groupLabel}
                data-lc-quick-buttons="1"
                style={{
                    position: 'absolute',
                    right: 0,
                    bottom,
                    width: 'max-content',
                    maxWidth: isMobile ? 'calc(100vw - 32px)' : 300,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 8,
                    pointerEvents: 'auto',
                }}
            >
                <button
                    type="button"
                    aria-label={dismissLabel}
                    onClick={onDismiss}
                    style={{
                        width: 26,
                        height: 26,
                        padding: 0,
                        border: 'var(--lc-hairline)',
                        borderRadius: 'var(--lc-radius-full)',
                        background: 'var(--lc-surface, #fff)',
                        boxShadow: 'var(--lc-shadow-1)',
                        color: 'var(--lc-text-2, #64748b)',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
                {buttons.map((button) => (
                    button.action === 'link' ? (
                        <a
                            key={button.id}
                            href={button.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={buttonStyle}
                            onClick={(e) => onAction(button, e)}
                        >
                            {button.text}
                        </a>
                    ) : (
                        <button key={button.id} type="button" style={buttonStyle} onClick={(e) => onAction(button, e)}>
                            {button.text}
                        </button>
                    )
                ))}
            </div>
        );
    }
}
